import cx from 'classnames';
import { useFormikContext } from 'formik';
import React from 'react';
import { useState } from 'react';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import { Sizes } from '../form-edits-components/Size';

const Paragraph = props => {
  const { text, size } = props.data;
  const { readOnly } = props;
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div
        className={cx('text-neutral-500', 'font-semibold', {
          'text-[14px]': size === Sizes.Small,
          'text-[16px]': size === Sizes.Medium,
          'text-[20px]': size === Sizes.Big,
        })}
      >
        <InlineEdit
          value={text}
          onChange={handleChange}
          fieldName="text"
          isEditing={isEditing}
          onSetIsEditing={setIsEditing}
          readOnly={readOnly}
        />
      </div>
    </FormElementWrapper>
  );
};

export default Paragraph;
